import { create } from "zustand";
import {
  addSupplier,
  getAllSuppliers,
  wareHouses,
  stockModuleUpdate,
  getStockReport,
  stockData,
  trackerData,
  warehouseInward,
  warehouseInwardData,
  warehouseOutwardData,
  inTransit,
  getSkuReport,
  getManualUpdation
} from "../api";

export const useSupplier = create((set) => ({
  suppliersData: [],
  wareHousesData: [],
  isError: false,
  isLoading: false,
  fetchSuppliers: async () => {
    set({ isLoading: true });
    try {
      const response = await getAllSuppliers();
      set({ suppliersData: response.data });
    } catch (error) {
      set({ isError: true });
    } finally {
      set({ isLoading: false });
    }
  },
  postSupplier: async (supplier, fetchSuppliers) => {
    set({ isLoading: true });
    try {
      await addSupplier(supplier);
      fetchSuppliers();
    } catch (error) {
      set({ isError: true });
    } finally {
      set({ isLoading: false });
    }
  },
  fetchWareHouses: async () => {
    set({ isLoading: true });
    try {
      const response = await wareHouses();
      set({ wareHousesData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true });
    }
  },
}));

export const useManualUpdate = create((set) => ({
  wareHousesData: [],
  isError: false,
  isLoading: false,
  fetchWareHouses: async () => {
    set({ isLoading: true });
    try {
      const response = await wareHouses();
      set({ wareHousesData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true });
    }
  },
  postModuleUpdate: async (payload, setToaster) => {
    set({ isLoading: true });
    try {
      await stockModuleUpdate(payload);
      setToaster("Stock Update", "Stock updated successfully", "success");
      set({ isLoading: false });
    } catch (error) {
      setToaster("Stock Update", "Stock update failed", "danger");
      set({ isError: true });
    }
  },
}));

export const useStockReportData = create((set) => ({
  stockReportData: [],
  isError: false,
  reportLoading: false,
  fetchStockReport: async (wareId, skuId) => {
    set({ reportLoading: true });
    try {
      const response = await getStockReport(wareId, skuId);
      set({ stockReportData: response.data, reportLoading: false });
    } catch (error) {
      set({ isError: true });
    }
  },
}));

export const useStockData = create((set) => ({
  stocksData: [],
  isError: false,
  stockReportLoading: false,
  fetchStockReport: async (wareId, skuId, displayId) => {
    set({ stockReportLoading: true });
    try {
      const response = await stockData(wareId, skuId, displayId);
      set({ stocksData: response.data, stockReportLoading: false });
    } catch (error) {
      set({ isError: true });
    }
  },
}));

export const useTrackerData = create((set) => ({
  trackerData: [],
  isError: false,
  trackerLoading: false,
  fetchTrackerData: async (wareId, skuId) => {
    set({ trackerLoading: true });
    try {
      const response = await trackerData(wareId, skuId);
      set({ trackerData: response.data, trackerLoading: false });
    } catch (error) {
      set({ isError: true });
    }
  },
}));

export const wareHouseInward = create((set,get) => ({
  inwardData: [],
  isError: false,
  inwardLoading: false,
  postLoading:false,
  fetchInwardData: async (wareId, towardWareId, skuId) => {
    set({ inwardLoading: true });
    try {
      const response = await warehouseInwardData(wareId, towardWareId, skuId);
      set({ inwardData: response.data, inwardLoading: false });
    } catch (error) {
      set({ isError: true });
    }
  },
  postInwardData: async (payload, setToaster, tab, getFunction) => {
    set({ postLoading: true });
    try {
      await warehouseInward(payload);
      const toasterData=tab=="inwards"?"Inward Created Successfully":tab==="outwards"?"outwards Created Successfully":"Allocation Successful";
      setToaster("Warehouse Inward", `${toasterData}`, "success");
      set({ postLoading: false });
      getFunction("","","");
    } catch (error) {
      set({ isError: true });
      const toasterData=tab==="inward"?"Inward CReated Failed":tab==="outward"?"outwards Created Failed":"Allocation Failed";
      setToaster("Warehouse Inward", toasterData, "danger");
    }
  },
}));

export const wareHouseOutwards = create((set) => ({
  outwardData: [],
  isError: false,
  outwardLoading: false,
  postLoading:false,
  fetchOutwardsData: async (wareId, towardWareId, skuId) => {
    set({ outwardLoading: true });
    try {
      const response = await warehouseOutwardData(wareId, towardWareId, skuId);
      set({ outwardData: response.data, outwardLoading: false });
    } catch (error) {
      set({ isError: true });
    }
  },
}));


export const wareHouseTransit = create((set) => ({
  transitData: [],
  isError: false,
  transitLoading: false,
  postLoading:false,
  fetchTransitData: async (wareId, towardWareId, skuId) => {
    set({ transitLoading: true });
    try {
      const response = await inTransit(wareId, towardWareId, skuId);
      set({ transitData: response.data, transitLoading: false });
    } catch (error) {
      set({ isError: true });
    }
  },
}));

export const skuReport = create((set)=>({
  isError: false,
  transitLoading: false,
  postLoading:false,
  fetchSkuReport: async (payload,setToaster) => {
    set({ transitLoading: true });
    try {
      await getSkuReport(payload);
      setToaster("Reports", `An email will be sent to you shortly`, "success");
    } catch (error) {
      set({ isError: true });
    }
  },
}))

export const manualUpdationLog = create((set)=>({
  manualUpdationData: [],
  isError: false,
  isLoading: false,
  fetchManualUpadtion: async (page) => {
    set({ isLoading: true });
    try {
      const response = await getManualUpdation(page);
      set({ manualUpdationData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true });
    }
  },
}))
